import styled, { css, keyframes } from 'styled-components';
import { zIndex, spacing, fontSize, breakpoints } from '../../common/theme/constants';
import { KitFlexRowSpaced } from '../KitFlexbox';

const slideTime = 0.5;

export const slideDownAnimation = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;  
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const slideUpAnimation = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

export const slideRightAnimation = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 0;
    
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideLeftAnimation = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const ModalOuter = styled.div<{
  windowHeight: number;
}>`
  width: 100vw;
  height: ${({ windowHeight }) => `${windowHeight}px`};
  position: fixed;
  background-color: #00000066;
  top: 0;
  z-index: ${zIndex.sliding_menu};
`;

export const SlideoutContainer = styled.div<{
  className?: string;
  visible?: boolean;
  windowHeight: number;
}>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  height: ${(props) => props.windowHeight}px;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.page.body.bg};
  @media all and (min-width: ${breakpoints.sm}px) {
    min-width: 320px;
  }
  z-index: 999;

  animation: ${(props) => {
    if (props.visible) {
      return css`
        ${slideTime}s ${slideRightAnimation} forwards
      `;
    }
    return css`
      ${slideTime}s ${slideLeftAnimation} forwards
    `;
  }};
`;

export const SlideOutHeader = styled(KitFlexRowSpaced)`
  align-items: center;
  padding: ${spacing.absolute.s}px;
  gap: ${spacing.absolute.s}px;
  @media all and (min-width: ${breakpoints.xs}px) {
    padding: ${spacing.absolute.m}px;
    gap: ${spacing.absolute.m}px;
  }
  border-bottom: 1px solid ${({ theme }) => theme.modal.separator};
`;

export const KitSlideOutBody = styled.div`
  padding: ${spacing.absolute.s}px;
  @media all and (min-width: ${breakpoints.xs}px) {
    padding: ${spacing.absolute.m}px;
  }
`;

export const KitSlideOutBodyWithBorder = styled(KitSlideOutBody)`
  border-bottom: 1px solid ${({ theme }) => theme.modal.separator};
`;

export const Heading = styled.h2`
  font-size: ${fontSize.text_20}rem;
  margin-bottom: 0;
`;
